import { Grid, Stack } from "@mui/material";
import { ReactElement } from "react";

interface InfoBlockProps {
  item?: boolean;
  LeftElement: ReactElement;
  RightElement: ReactElement;
  BottomElement?: ReactElement;
  ControlsElement?: ReactElement;
}

const InfoBlock = ({ item = false, LeftElement, RightElement, BottomElement, ControlsElement }: InfoBlockProps) => {
  return (
    <Grid
      container
      item={item}
      spacing={2.5}
      // Для предотвращения warning
      {...(item && { xs: 12 })}>
      <Grid
        item
        xs={12}
        md={6}>
        <Stack spacing={2}>{LeftElement}</Stack>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}>
        <Stack spacing={2}>{RightElement}</Stack>
      </Grid>
      {BottomElement && (
        <Grid
          item
          xs={12}>
          <Stack spacing={2}>{BottomElement}</Stack>
        </Grid>
      )}
      {Boolean(ControlsElement) && (
        <Grid
          item
          xs={12}
          md={3}>
          {ControlsElement}
        </Grid>
      )}
    </Grid>
  );
};

export default InfoBlock;
